import { useOrganizationPermissions } from '@/hooks/useOrganizationPermissions';
import { usePermissions } from '@/hooks/usePermissions';

export const usePostFieldOptions = (options: {
  organizationId?: string;
  editing?: boolean;
}): {
  showSponsoredPostOption: boolean;
  showTagsSelector: boolean;
  showGroupsSelector: boolean;
} => {
  const organizationPermissions = useOrganizationPermissions(
    options?.organizationId || undefined
  );

  const permissions = usePermissions();

  if (organizationPermissions.isLoading || permissions.isLoading) {
    return {
      showSponsoredPostOption: false,
      showTagsSelector: false,
      showGroupsSelector: false,
    };
  }

  const showSponsoredPostOption =
    !!options.organizationId &&
    (organizationPermissions.canCreateOrganizationSponsoredPosts ||
      organizationPermissions.canAttemptToCreateOrganizationSponsoredPostsWithPaywall) &&
    !options.editing;

  return {
    showSponsoredPostOption,
    showGroupsSelector: !options.organizationId,
    showTagsSelector:
      !options.organizationId ||
      organizationPermissions.canAddTagsToPostInOrganization,
  };
};
